import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'semantic-ui-react';
import { EMAIL_ERROR_MESSAGE, EMAIL_PLACEHOLDER } from './EmailField.constants';
import { isValidEmail } from '../../../utils/strings';
import './EmailField.css';
var defaultProps = {
  name: 'email',
  defaultValue: '',
  onChange: null,
  value: undefined,
  required: false
};
function EmailField(_ref) {
  var name = _ref.name,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    value = _ref.value,
    required = _ref.required;
  var _useRef = useRef(value !== undefined),
    isControlled = _useRef.current;
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    emailStateValue = _useState2[0],
    setEmailStateValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    message = _useState4[0],
    setMessage = _useState4[1];
  var valueDerived = isControlled ? value : emailStateValue;
  useEffect(function () {
    if (!isControlled) {
      if (!!valueDerived && !isValidEmail(valueDerived)) {
        setMessage(EMAIL_ERROR_MESSAGE);
      } else {
        setMessage('');
      }
    }
  }, [valueDerived]);
  function handleOnChange(e, target) {
    var _target$value = target.value,
      email = _target$value === void 0 ? '' : _target$value;
    var loweredCaseEmail = email.toLowerCase();
    if (!isControlled) {
      setEmailStateValue(loweredCaseEmail);
    }
    if (onChange) {
      onChange(e, _objectSpread(_objectSpread({}, target), {}, {
        value: loweredCaseEmail
      }));
    }
  }
  return /*#__PURE__*/React.createElement(Form.Field, {
    className: "email-field-container"
  }, /*#__PURE__*/React.createElement(Form.Input, {
    label: "Email Address",
    type: "email",
    value: valueDerived,
    name: name,
    placeholder: EMAIL_PLACEHOLDER,
    onChange: handleOnChange,
    required: required,
    fluid: true
  }), message && /*#__PURE__*/React.createElement("div", {
    className: "email-field-error"
  }, message, " "));
}
EmailField.defaultProps = defaultProps;
export default EmailField;